import React from "react"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import Dietetique from "@Screens/Knowledge/Savoirs/Dietetique/Dietetique"
import PhysicalActivity from "@Screens/Knowledge/Savoirs/PhysicalActivity/PhysicalActivity"
import Evaluation from "@Screens/Knowledge/Savoirs/Evaluation/Evaluation"
import Psycho from "@Screens/Knowledge/Savoirs/Psycho/Psycho"
import Medical from "@Screens/Knowledge/Savoirs/Medical/Medical"

const Tab = createMaterialTopTabNavigator()

const SavoirsTopTabStack = () => {
    const screens = [
        {
            tabBarLabel: "Diététique",
            name: "Dietetique",
            component: Dietetique
        },
        {
            tabBarLabel: "Medical",
            name: "Medical",
            component: Medical
        },
        {
            tabBarLabel: "Activité physique adaptée",
            name: "Activity",
            component: PhysicalActivity
        },
        {
            tabBarLabel: "Psycho",
            name: "Psycho",
            component: Psycho
        },
        {
            tabBarLabel: "Évaluation",
            name: "Evaluation",
            component: Evaluation
        }
    ]

    const screenOptions = {
        tabBarPressColor: baseColors.green.primary,
        tabBarActiveTintColor: baseColors.green.primary,
        tabBarInactiveTintColor: baseColors.black,
        tabBarScrollEnabled: true,
        tabBarItemStyle: { width: "auto" },
        tabBarLabelStyle: {
            fontSize: 14,
            fontFamily: baseFontFamily.OpenSansBold
        },
        tabBarIndicatorStyle: { backgroundColor: baseColors.green.primary, height: 4 }
    }

    return (
        <Tab.Navigator screenOptions={screenOptions} initialRouteName="Dietetique">
            {screens.map((item, i) => (
                <Tab.Screen
                    key={i}
                    name={item.name}
                    options={{ tabBarLabel: item.tabBarLabel }}
                    component={item.component}
                />
            ))}
        </Tab.Navigator>
    )
}

export default SavoirsTopTabStack
